import 'antd/dist/reset.css';
import './index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';

import { App } from 'containers/App';
import { init as sentryInit } from 'lib/sentry';
import { AntdThemeProvider } from 'theme/antd';

import * as serviceWorker from './serviceWorker';

sentryInit();

ConfigProvider.config({
  holderRender: (children) => <AntdThemeProvider>{children}</AntdThemeProvider>,
});

createRoot(document.getElementById('root')!).render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
